export type ComposeEmojiCategory = {
  id: string;
  label: string;
  emojis: string[];
};

/** Bibliothèque emojis rédaction mail (Unicode natif). */
export const COMPOSE_EMOJI_CATEGORIES: ComposeEmojiCategory[] = [
  {
    id: "smileys",
    label: "Smileys",
    emojis: [
      "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "🙃",
      "😉", "😊", "😇", "🥰", "😍", "🤩", "😘", "😗", "☺", "😚",
      "😙", "🥲", "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭",
      "🫢", "🫣", "🤫", "🤔", "🫡", "🤐", "🤨", "😐", "😑", "😶",
      "🫥", "😏", "😒", "🙄", "😬", "🤥", "😌", "😔", "😪", "🤤",
      "😴", "😷", "🤒", "🤕", "🤢", "🤮", "🥴", "😵", "🤯", "🤠",
      "🥳", "🥸", "😎", "🤓", "🧐", "😕", "🫤", "😟", "🙁", "☹",
      "😮", "😯", "😲", "😳", "🥺", "🥹", "😦", "😧", "😨", "😰",
      "😥", "😢", "😭", "😱", "😖", "😣", "😞", "😓", "😩", "😫",
      "🥱", "😤", "😡", "😠", "🤬", "😈", "👿", "💀", "☠", "💩",
    ],
  },
  {
    id: "gestures",
    label: "Gestes",
    emojis: [
      "👋", "🤚", "🖐", "✋", "🖖", "🫱", "🫲", "🫳", "🫴", "👌",
      "🤌", "🤏", "✌", "🤞", "🫰", "🤟", "🤘", "🤙", "👈", "👉",
      "👆", "🖕", "👇", "☝", "🫵", "👍", "👎", "✊", "👊", "🤛",
      "🤜", "👏", "🙌", "🫶", "👐", "🤲", "🤝", "🙏", "✍", "💅",
      "🤳", "💪", "🦾", "🦿", "🦵", "🦶", "👂", "🦻", "👃", "🧠",
      "👀", "👁", "👅", "👄", "🫦", "👶", "🧒", "👦", "👧", "🧑",
      "👱", "👨", "🧔", "👩", "🧓", "👴", "👵", "🙍", "🙎", "🙅",
      "🙆", "💁", "🙋", "🧏", "🙇", "🤦", "🤷", "💆", "💇", "🚶",
    ],
  },
  {
    id: "hearts",
    label: "Cœurs",
    emojis: [
      "❤", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔",
      "❣", "💕", "💞", "💓", "💗", "💖", "💘", "💝", "💟", "♥",
      "💌", "💋", "😻", "💑", "👩‍❤‍👨", "👨‍❤‍👨", "👩‍❤‍👩", "💏", "🌹", "🥀",
    ],
  },
  {
    id: "animals",
    label: "Animaux",
    emojis: [
      "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐻‍❄", "🐨",
      "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🙈", "🙉", "🙊", "🐒",
      "🐔", "🐧", "🐦", "🐤", "🦆", "🦅", "🦉", "🦇", "🐺", "🐗",
      "🐴", "🦄", "🐝", "🪱", "🐛", "🦋", "🐌", "🐞", "🐜", "🪰",
      "🐢", "🐍", "🦎", "🦖", "🦕", "🐙", "🦑", "🦐", "🦞", "🐠",
      "🐟", "🐬", "🐳", "🐋", "🦈", "🐊", "🐅", "🐆", "🦓", "🦍",
    ],
  },
  {
    id: "food",
    label: "Nourriture",
    emojis: [
      "🍎", "🍐", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🫐", "🍈",
      "🍒", "🍑", "🥭", "🍍", "🥥", "🥝", "🍅", "🍆", "🥑", "🥦",
      "🥬", "🥒", "🌶", "🫑", "🌽", "🥕", "🫒", "🧄", "🧅", "🥔",
      "🍞", "🥐", "🥖", "🥨", "🧀", "🥚", "🍳", "🧈", "🥞", "🧇",
      "🥓", "🍗", "🍖", "🌭", "🍔", "🍟", "🍕", "🫓", "🥪", "🌮",
      "🌯", "🫔", "🥙", "🧆", "🥗", "🍝", "🍜", "🍲", "🍛", "🍣",
      "🍱", "🥟", "🦪", "🍤", "🍙", "🍚", "🍘", "🍥", "🥠", "🥮",
      "🍢", "🍡", "🍧", "🍨", "🍦", "🥧", "🧁", "🍰", "🎂", "🍮",
      "🍭", "🍬", "🍫", "🍿", "🍩", "🍪", "☕", "🍵", "🧃", "🥤",
      "🍺", "🍻", "🥂", "🍷", "🥃", "🍸", "🍹", "🧉", "🍾", "🧊",
    ],
  },
  {
    id: "travel",
    label: "Voyage",
    emojis: [
      "🚗", "🚕", "🚙", "🚌", "🚎", "🏎", "🚓", "🚑", "🚒", "🚐",
      "🛻", "🚚", "🚛", "🚜", "🏍", "🛵", "🚲", "🛴", "🚨", "🚔",
      "✈", "🛫", "🛬", "🚀", "🛸", "🚁", "🛶", "⛵", "🚤", "🛥",
      "🛳", "⛴", "🚢", "⚓", "🗼", "🗽", "🗿", "🗺", "🗾", "🏔",
      "⛰", "🌋", "🏕", "🏖", "🏜", "🏝", "🏞", "🏟", "🏛", "🏗",
      "🧱", "🏘", "🏠", "🏡", "🏢", "🏣", "🏤", "🏥", "🏦", "🏨",
      "🏩", "🏪", "🏫", "🏬", "🏭", "🏯", "🏰", "💒", "🕌", "⛪",
      "🛕", "🕍", "⛩", "🌁", "🌃", "🌄", "🌅", "🌆", "🌇", "🌉",
    ],
  },
  {
    id: "activities",
    label: "Activités",
    emojis: [
      "⚽", "🏀", "🏈", "⚾", "🥎", "🎾", "🏐", "🏉", "🥏", "🎱",
      "🪀", "🏓", "🏸", "🏒", "🏑", "🥍", "🏏", "🪃", "🥅", "⛳",
      "🪁", "🏹", "🎣", "🤿", "🥊", "🥋", "🎽", "🛹", "🛼", "🛷",
      "⛸", "🥌", "🎿", "⛷", "🏂", "🪂", "🏋", "🤼", "🤸", "⛹",
      "🤺", "🤾", "🏌", "🏇", "🧘", "🏄", "🏊", "🤽", "🚣", "🧗",
      "🎪", "🎭", "🎨", "🎬", "🎤", "🎧", "🎼", "🎹", "🥁", "🎷",
      "🎺", "🎸", "🪕", "🎻", "🎲", "♟", "🎯", "🎳", "🎮", "🕹",
      "🎰", "🧩", "🎉", "🎊", "🎈", "🎁", "🎀", "🎗", "🏆", "🥇",
    ],
  },
  {
    id: "objects",
    label: "Objets",
    emojis: [
      "📧", "📨", "📩", "📤", "📥", "📦", "📫", "📪", "📬", "📭",
      "📮", "🗳", "✏", "✒", "🖋", "🖊", "🖌", "🖍", "📝", "💼",
      "📁", "📂", "🗂", "📅", "📆", "🗒", "🗓", "📇", "📈", "📉",
      "📊", "📋", "📌", "📍", "📎", "🖇", "📏", "📐", "✂", "🗃",
      "🗄", "🗑", "🔒", "🔓", "🔏", "🔐", "🔑", "🗝", "🔨", "🪓",
      "⛏", "⚒", "🛠", "🗡", "⚔", "🔫", "🪃", "🏹", "🛡", "🪚",
      "🔧", "🔩", "⚙", "🗜", "⚖", "🦯", "🔗", "⛓", "🪝", "🧰",
      "🧲", "⚗", "🧪", "🧫", "🧬", "🔬", "🔭", "📡", "💉", "🩸",
      "💊", "🩹", "🩺", "🚪", "🛏", "🛋", "🪑", "🚽", "🪠", "🚿",
      "🛁", "🪒", "🧴", "🧷", "🧹", "🧺", "🧻", "🪣", "🧼", "🫧",
      "💡", "🔦", "🏮", "🪔", "📱", "📲", "💻", "🖥", "🖨", "⌨",
      "🖱", "💾", "💿", "📀", "🎥", "📷", "📸", "📹", "🎙", "🔋",
    ],
  },
  {
    id: "symbols",
    label: "Symboles",
    emojis: [
      "❤", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "💯", "💢",
      "💥", "💫", "💦", "💨", "🕳", "💬", "👁‍🗨", "🗨", "🗯", "💭",
      "💤", "🔔", "🔕", "🎵", "🎶", "💹", "✅", "☑", "✔", "❌",
      "❎", "➕", "➖", "➗", "✖", "♾", "‼", "⁉", "❓", "❔",
      "❕", "❗", "〰", "💱", "🔱", "⚜", "🔰", "⭕", "➰", "➿",
      "®", "™", "🔴", "🟠", "🟡", "🟢", "🔵", "🟣", "🟤", "⚫",
      "⚪", "🟥", "🟧", "🟨", "🟩", "🟦", "🟪", "🟫", "⬛", "⬜",
      "🔶", "🔷", "🔸", "🔹", "🔺", "🔻", "💠", "🔘", "🔳", "🔲",
      "⭐", "🌟", "✨", "⚡", "🔥", "💧", "🌈", "☀", "⛅", "☁",
      "❄", "⛄", "☃", "🌬", "🌪", "🌫", "☔", "⚠", "🚸", "〽",
      "✳", "✴", "❇", "©", "®", "™",
    ],
  },
  {
    id: "flags",
    label: "Drapeaux",
    emojis: [
      "🏳", "🏴", "🏁", "🚩", "🏳‍🌈", "🏳‍⚧", "🇫🇷", "🇧🇪", "🇨🇭", "🇨🇦",
      "🇺🇸", "🇬🇧", "🇩🇪", "🇪🇸", "🇮🇹", "🇵🇹", "🇳🇱", "🇱🇺", "🇲🇨", "🇦🇩",
      "🇲🇦", "🇹🇳", "🇩🇿", "🇸🇳", "🇨🇮", "🇨🇲", "🇬🇦", "🇨🇩", "🇲🇬", "🇷🇪",
      "🇬🇵", "🇲🇶", "🇵🇫", "🇳🇨", "🇯🇵", "🇨🇳", "🇰🇷", "🇮🇳", "🇧🇷", "🇲🇽",
      "🇦🇷", "🇨🇱", "🇨🇴", "🇵🇪", "🇦🇺", "🇳🇿", "🇿🇦", "🇪🇬", "🇹🇷", "🇷🇺",
      "🇵🇱", "🇨🇿", "🇦🇹", "🇸🇪", "🇳🇴", "🇩🇰", "🇫🇮", "🇮🇪", "🇬🇷", "🇷🇴",
    ],
  },
];

export const COMPOSE_EMOJI_COUNT = COMPOSE_EMOJI_CATEGORIES.reduce(
  (total, category) => total + category.emojis.length,
  0
);
